// The door from the real game into the what-if sandbox: a link that forks the real world on the
// date shown. The sandbox is another page load ('?timeline=fiction'), so the real game never
// loads sandbox code; the setup screen clamps the date into its fork range.

import type { DateStr } from '../core/schema.ts';
import { FICTION_ROUTE } from '../services/fiction/api.ts';

/** '?timeline=fiction&fork=<date>[&nation=<iso3>]': the setup screen opens prefilled. */
export function whatIfHref(date: DateStr, iso3: string | null): string {
  const params = new URLSearchParams({ [FICTION_ROUTE.param]: FICTION_ROUTE.value, [FICTION_ROUTE.fork]: date });
  if (iso3) {
    params.set(FICTION_ROUTE.nation, iso3);
  }
  return `?${params.toString()}`;
}
